import Config from '../../../config';
import { fetchingError, showAlert } from '../../../shared/store/actions';
import { infoNotification } from '../../../shared/store/notificationActions';

import alertTypes from '../../../shared/alertTypes';

import {
  UPLOAD_TRIAL_BALANCE_FILE,
  SET_TRIAL_BALANCE_FILTER,
  UNSET_TRIAL_BALANCE_FILTER,
} from './types';
import { UPLOAD_TRIAL_BALANCE_FILE_FAILURE, UPLOAD_TRIAL_BALANCE_FILE_SUCCESS } from '../../store/types';

import { addJob } from '../../../shared/jim/store/actions';

export const setTrialBalanceFilter = filter => ({
  type: SET_TRIAL_BALANCE_FILTER,
  filter,
});

export const unsetTrialBalanceFilter = () => ({
  type: UNSET_TRIAL_BALANCE_FILTER,
});

export const uploadTrialBalanceFile = ({
  file,
  companyCode,
  period,
  companySource,
}) => async dispatch => {
  try {
    await dispatch({
      type: UPLOAD_TRIAL_BALANCE_FILE,
    });
    dispatch(infoNotification('Trial Balance File Upload Processing...'));

    await dispatch(
      addJob({
        jobType: Config.jimJobs.trialBalanceImport.type,
        payload: {
          file,
          companySource,
          companyCode,
          isBeginningBalance: false,
          period: period.name,
        },
      })
    );

    dispatch({
      type: UPLOAD_TRIAL_BALANCE_FILE_SUCCESS,
    });
  } catch (error) {
    dispatch(fetchingError());
    dispatch({
      type: UPLOAD_TRIAL_BALANCE_FILE_FAILURE,
    });

    dispatch(showAlert(error.message, alertTypes.DANGER));
  }
};
